'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLoadA = function IoLoadA(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.3 7.5c0-3.4 1.6-5 5-5s5 1.6 5 5-1.7 5-5 5-5-1.6-5-5z m-11.3 12.5c0-2.5 1.3-3.7 3.8-3.7s3.7 1.2 3.7 3.7-1.2 3.8-3.7 3.8-3.8-1.3-3.8-3.8z m24.4-8.7c0-0.4 0.2-0.7 0.6-0.7s0.6 0.3 0.6 0.7-0.2 0.6-0.6 0.6-0.6-0.3-0.6-0.6z m-14.1-2.9c0.8 0.8 1.2 1.8 1.2 2.9s-0.4 2-1.2 2.8-1.7 1.1-2.8 1.1-2-0.4-2.8-1.1-1.2-1.8-1.2-2.8 0.4-2.1 1.2-2.9 1.7-1.1 2.8-1.1 2 0.4 2.8 1.1z m17.2 11.6c0-0.9 0.4-1.2 1.3-1.2s1.2 0.3 1.2 1.2-0.4 1.3-1.2 1.3-1.3-0.4-1.3-1.3z m-4.3 8.8c0-1.2 0.6-1.8 1.9-1.8s1.9 0.6 1.9 1.8-0.7 1.9-1.9 1.9-1.9-0.6-1.9-1.9z m-9.4 3.7c0-1.6 0.8-2.5 2.5-2.5s2.5 0.9 2.5 2.5-0.9 2.5-2.5 2.5-2.5-0.9-2.5-2.5z m-9.4-3.7c0-2.2 1-3.2 3.1-3.2s3.1 1 3.1 3.2-1 3.1-3.1 3.1-3.1-1-3.1-3.1z' })
        )
    );
};

exports.default = IoLoadA;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/load-a.js
// module id = 2817
// module chunks = 168707334958949